import { motion } from 'motion/react'
import { Link } from 'react-router'

export default function LandingHeroLaunch() {
	return (
		<section className="relative flex min-h-[85vh] w-full items-center justify-center overflow-hidden px-6 py-24">
			<div
				aria-hidden
				className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(ellipse_60%_50%_at_50%_0%,theme(colors.indigo.500/15%),transparent)]"
			/>
			<motion.div
				initial={{ opacity: 0, y: 24 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8, ease: 'easeOut' }}
				className="relative z-10 mx-auto max-w-3xl text-center"
			>
				<h1 className="text-foreground text-5xl leading-tight font-extrabold tracking-tight drop-shadow-[0_0_20px_rgba(255,255,255,0.85)] md:text-6xl lg:text-7xl dark:drop-shadow-[0_0_20px_rgba(8,10,20,0.85)]">
					Your podcast.{' '}
					<span className="bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
						Without the background noise.
					</span>
				</h1>
				<p className="text-base-content/70 mx-auto mt-6 max-w-2xl text-lg md:text-xl">
					Upload your recording and Podly removes background noise, polishing it
					into a clean, professional episode in minutes.
				</p>
				<motion.div
					initial={{ opacity: 0, y: 16 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
					className="mt-10 flex flex-col items-center gap-4"
				>
					<Link
						to="/editor"
						className="group relative rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 px-10 py-4 text-lg font-bold text-white shadow-lg shadow-indigo-500/50 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-indigo-500/60"
					>
						Clean Up My Audio — Free
					</Link>
					<p className="text-base-content/50 text-sm">
						No credit card required.
					</p>
				</motion.div>
			</motion.div>
		</section>
	)
}
